<template>
  <v-row class="mt-3" dense>
    <div v-for="item in $store.state.cart.items" :key="item.id" class="mb-2">
      <v-responsive :aspect-ratio="1" class="mr-3" width="80px">
        <v-card outlined class="position-relative">
          <ProxyImage :src="item.primary_picture" @click="select(item)" alt="Item" class="cursor-pointer"></ProxyImage>
          <v-badge
            :content="item.unit" class="absolute" style="top: 20px; right: 20px"
            :color="item.monthly_amount > 0 ? 'blue' : 'red'"
          ></v-badge>
        </v-card>
      </v-responsive>
    </div>

    <v-bottom-sheet inset max-width="500" v-if="$vuetify.breakpoint.smAndDown" v-model="preview">
      <CartListItemContent :item="selected" @close="preview = false"/>
    </v-bottom-sheet>

    <v-navigation-drawer fixed right temporary v-else v-model="preview" width="450">
      <CartListItemContent :item="selected" @close="preview = false"/>
    </v-navigation-drawer>
  </v-row>
</template>

<script>
import CartListItemContent from "./CartListItemContent";
import ProxyImage from "../ProxyImage";

export default {
  name: "CartListItems",
  components: { ProxyImage, CartListItemContent },
  data() {
    return {
      preview: false,
      selected: null
    }
  },
  methods: {
    select(item) {
      this.selected = item;
      this.preview = true;
    },
  },
  watch: {
    preview(v) {
      if (!v) this.selected = null
    }
  }
}
</script>

